import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import RadioBlock from '../../../../../../../../../components/Form/RadioBlock'
import CreateLeadAdsFormLink from '../../../../../../CreateLeadAdsFormLink'
import Field from '../../../../../../../../../components/Form/Field'

import { formatOptionsList } from '../../../../../../../../../features/formatters'

import { FB_PAGE_CHOICE } from '../../../../../../../AdForms/fields'
import {
  accessibleSocialPagesIsLoadingSelector,
  accessibleSocialPagesSelector
} from '../../../../../../../../../modules/selectors/socialAccounts'
import { CONVERSION_EVENT_TYPE_RADIO_BUTTON, LEADS_ON_META_LEAD_ADS_FORM } from '../../../../fields'

const LeadAdsFormRadioBlock = ({ formik }) => {
  const { t } = useTranslation()
  const { setFieldValue, values } = formik

  const facebookPages = useSelector(accessibleSocialPagesSelector)
  const facebookPagesLoading = useSelector(accessibleSocialPagesIsLoadingSelector)
  const formattedFacebookPages = useMemo(
    () =>
      formatOptionsList({
        list: facebookPages,
        valueName: 'external_id',
        labelName: 'name'
      }),
    [facebookPages]
  )

  return (
    <RadioBlock
      setFieldValue={setFieldValue}
      id={LEADS_ON_META_LEAD_ADS_FORM}
      name={CONVERSION_EVENT_TYPE_RADIO_BUTTON}
      label={t('Leads on a Meta Lead Ads form')}
      value={LEADS_ON_META_LEAD_ADS_FORM}
      selectedValue={values[CONVERSION_EVENT_TYPE_RADIO_BUTTON]}
    >
      <p>{t('Select which page the Lead Ads form is associated with.')}</p>
      <CreateLeadAdsFormLink />
      <Field
        placeholder={t('Facebook page')}
        formik={formik}
        name={FB_PAGE_CHOICE}
        options={formattedFacebookPages}
        isLoading={facebookPagesLoading}
        isMulti={false}
        isSearchable={false}
      />
    </RadioBlock>
  )
}

export default LeadAdsFormRadioBlock
